<template>
  <div class="referral-input" :class="[`referral-input-${type}-wrapper`, hasError && 'has-error']">
    <div class="referral-input-prefix">{{ referralSymbol }}</div>
    <NumberInput v-model="elValue" :min="min" :skip-validate="skipValidate" :disabled="disabled"></NumberInput>
  </div>
</template>

<script>
import NumberInput from './numberInput'

export default {
  components: {
    NumberInput
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    type: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      default: null
    },
    skipValidate: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.referral',
      hasError: false
    }
  },
  computed: {
    elValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    referralSymbol () {
      const symbols = {
        cash: this.$t(`${this.i18nPrefix}.symbols.cash`),
        point: this.$t(`${this.i18nPrefix}.symbols.point`)
      }
      return symbols[this.type]
    }
  },
  created () {

  },
  methods: {
    showError (inputName) {
      this.hasError = true
    },
    clearError (inputName) {
      this.hasError = false
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.referral-input {
  display: inline-block;
  width: 100%;
  position: relative;

  &.has-error {
    .referral-input-prefix {
      color: #fff;
    }

    ::v-deep {
      .el-input__inner {
        border: 1px solid #c60000;
        background-color: #c60000;
        color: #fff;
      }
    }
  }

  .referral-input-prefix {
    height: 100%;
    line-height: 40px;
    color: #232323;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  &.referral-input-cash-wrapper {
    .referral-input-prefix {
      width: 18px;
    }

    .el-input {
      ::v-deep {
        .el-input__inner {
          padding-left: 18px;
          padding-right: 2px;
        }
      }
    }
  }

  &.referral-input-point-wrapper {
    .referral-input-prefix {
      width: 34px;
      padding-left: 5px;
    }

    .el-input {
      ::v-deep {
        .el-input__inner {
          padding-left: 35px;
          padding-right: 2px;
        }
      }
    }
  }
}
.page-en {
  .referral-input {
    &.referral-input-point-wrapper {
      .referral-input-prefix {
        width: 38px;
      }

      .el-input {
        ::v-deep {
          .el-input__inner {
            padding-left: 50px;
          }
        }
      }
    }
  }
}
</style>
